import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { HttpRequestService } from '../../services/HttpRequestService';
import { UtilsService } from '../../services/UtilsService';
import Checkbox from '../../common/Checkbox';
import FileInput from '../../common/FileInput';
import Report from '../../common/Report';
import CompanySelect from '../../common/CompanySelect';

class TikTokReconciliation extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        this.state = {
            paymentFile: null,
            mismatchedOnly: false,
            splitOnly: false,
            companyId: 2,
            report: null
        }
        this.sortBy = "";
        this.sortDirection = "";
        this.http = new HttpRequestService();
        this.utils = new UtilsService();
        this.handlePaymentFileChange = this.handlePaymentFileChange.bind(this);
        this.handleMismatchedOnlyChange = this.handleMismatchedOnlyChange.bind(this);
        this.handleSplitOnlyChange = this.handleSplitOnlyChange.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);
        this.getReport = this.getReport.bind(this);
    }

    componentDidMount() {
    }

    handlePaymentFileChange(file) {
        this.setState({
            paymentFile: file
        });
    }

    handleCompanyChange(companyId) {
        this.setState({ companyId: companyId });
    }

    handleMismatchedOnlyChange(checked) {
        this.setState({ mismatchedOnly: checked });
    }

    handleSplitOnlyChange(checked) {
        this.setState({ splitOnly: checked });
    }

    getReport() {
        var params = {
            companyId: this.state.companyId,
            mismatchedOnly: this.state.mismatchedOnly,
            splitOnly: this.state.splitOnly,
            operation: "ReconcileTikTokOrders",
            sortBy: this.sortBy,
            sortDirection: this.sortDirection
        }

        this.http.upload('/api/FileUpload/UploadFile/', this.state.paymentFile, params).then(data => {
            this.setState({
                report: data
            })
        });
    }

    sortReport(field) {
        if (this.sortBy !== field) {
            this.sortDirection = "ASC";
        }
        else {
            if (this.sortDirection === "ASC") {
                this.sortDirection = "DESC";
            }
            else {
                this.sortDirection = "ASC";
            }
        }
        this.sortBy = field;
        this.getReport();
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Reconcile TikTok Orders</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="form-row">
                                    <div className="form-group col-md-12">
                                        <label>Payment File</label>
                                        <br />
                                        <FileInput label="Select File" onChange={this.handlePaymentFileChange}></FileInput>
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Company</label>
                                        <CompanySelect value={this.state.companyId} onChange={this.handleCompanyChange}>
                                        </CompanySelect>
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>&nbsp;</label>
                                        <Checkbox label="Display mismatched orders only" checked={this.state.mismatchedOnly} onChange={this.handleMismatchedOnlyChange}></Checkbox>
                                    </div>
                                    <div className="form-group col-md-3">
                                        <button className="btn btn-primary mt-4" onClick={this.getReport}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.report != null &&
                            <Report name="TikTokReconciliationReport" hasData={this.state.report.items && this.state.report.items.length > 0}>
                                <div className="form-row">
                                    <table className="table table-bordered table-striped mt-1 report-table">
                                        <thead>
                                            <tr>
                                                <th colSpan={5}></th>
                                                <th className="separator"></th>
                                                <th colSpan={2}><h3>PowerD</h3></th>
                                                <th className="separator"></th>
                                                <th colSpan={7}><h3>TikTok</h3></th>
                                            </tr>
                                            <tr>
                                                <th className="sortable" scope="col" onClick={(e) => this.sortReport("TikTokOrderId")}>TIKTOK ORDER #</th>
                                                <th className="sortable" scope="col" onClick={(e) => this.sortReport("OrderNumber")}>ORDER #</th>
                                                <th className="sortable" scope="col" onClick={(e) => this.sortReport("Date")}>DATE</th>                                                
                                                <th className="sortable" scope="col" onClick={(e) => this.sortReport("Customer")}>CUSTOMER</th>
                                                <th className="sortable" scope="col" onClick={(e) => this.sortReport("State")}>STATE</th>
                                                <th className="separator"></th>
                                                <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("PowerDProductCharges")}>PRODUCT CHARGES</th>                                                
                                                <th className="separator"></th>
                                                <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("TikTokOrder.ProductCharges")}>PRODUCT CHARGES</th>
                                                <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("TikTokOrder.FulfillmentFee")}>FULFILLMENT FEE</th>
                                                <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("TikTokOrder.OtherFees")}>OTHER FEES</th>
                                                <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("TikTokOrder.TotalFees")}>TOTAL FEES</th>
                                                <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("TikTokOrder.TotalSettlementAmount")}>SETTLEMENT AMOUNT</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.report.items && this.state.report.items.map(item =>
                                                <tr key={item.orderID}>
                                                    <td className={(!item.tikTokOrderId ? "bg-danger" : "") + ((item.tikTokOrder && item.tikTokOrder.isSplit ? " bg-warning" : ""))}>{item.tikTokOrderId}</td>
                                                    <td className={!item.orderNumber ? "bg-danger" : ""}><Link to={"/order/" + item.orderId} target="_blank" rel="noopener noreferrer">{item.orderNumber}</Link></td>
                                                    <td>{item.date}</td>                                                    
                                                    <td><Link to={"/customer/" + item.customerId} target="_blank">{item.customer}</Link></td>
                                                    <td>{item.state}</td>
                                                    <td className="separator"></td>
                                                    <td className={"currency " + (item.powerDProductCharges !== item.tikTokOrder.productCharges ? "bg-danger" : "")}>{this.utils.toCurrency(item.powerDProductCharges, item.powerDCurrency)}</td>                                                    
                                                    <td className="separator"></td>
                                                    <td className="currency">{this.utils.toCurrency(item.tikTokOrder.productCharges, item.tikTokOrder.currency)}</td>
                                                    <td className="currency">{this.utils.toCurrency(item.tikTokOrder.fulfillmentFee, item.tikTokOrder.currency)}</td>
                                                    <td className="currency">{this.utils.toCurrency(item.tikTokOrder.otherFees, item.tikTokOrder.currency)}</td>
                                                    <td className="currency">{this.utils.toCurrency(item.tikTokOrder.totalFees, item.tikTokOrder.currency)}</td>
                                                    <td className="currency">{this.utils.toCurrency(item.tikTokOrder.totalSettlementAmount, item.tikTokOrder.currency)}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tbody>
                                            <tr className="bg-dark reportFooter">
                                                <th colSpan={5}></th>
                                                <td className="separator"></td>
                                                <td className="currency">{this.utils.toCurrency(this.state.report.powerDProductCharges, this.state.report.currency)}</td>                                            
                                                <td className="separator"></td>
                                                <td className="currency">{this.utils.toCurrency(this.state.report.tikTokProductCharges, this.state.report.currency)}</td>
                                                <td className="currency">{this.utils.toCurrency(this.state.report.tikTokFulfillmentFees, this.state.report.currency)}</td>
                                                <td className="currency">{this.utils.toCurrency(this.state.report.tikTokOtherFees, this.state.report.currency)}</td>
                                                <td className="currency">{this.utils.toCurrency(this.state.report.tikTokTotalFees, this.state.report.currency)}</td>
                                                <td className="currency">{this.utils.toCurrency(this.state.report.tikTokTotalSettlementAmount, this.state.report.currency)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Report>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default TikTokReconciliation;
